import { PATHS } from './paths';

export interface NavLink {
  label: string;
  path: string;
}

export interface NavSection {
  label: string;
  path: string;
  children?: NavLink[];
}

export const MAIN_NAV: NavSection[] = [
  { label: 'Start', path: PATHS.home },
  { label: 'Leistungen', path: '/#leistungen' },
  { label: 'Vorgehensweisen', path: '/#methodik' },
  { label: 'Team', path: '/#team' },
  { label: 'Aktuelles', path: '/#aktuelles' },
  { label: 'Kontakt', path: '/#kontakt' },
];

export const LEGAL_NAV: NavLink[] = [
  { label: 'Impressum', path: PATHS.impressum },
  { label: 'Datenschutz', path: PATHS.datenschutz },
  { label: 'Widerrufsbelehrung', path: PATHS.widerruf },
];
